import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ResourceCard from "./ResourceCard";
import { resourcesForModule } from "../lib/resourcesData";

export default function ResourcesSection({
  moduleKey,
  eyebrow = "Resources",
  heading,
  subhead,
  contained = false,
  eyebrowColor = "text-primary",
}) {
  const docs = resourcesForModule(moduleKey);
  if (!docs.length) return null;

  return (
    <section
      id="resources"
      className={`mb-section-gap ${contained ? "w-full px-margin-mobile md:px-gutter max-w-container-max mx-auto" : ""}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-stack-lg max-w-2xl mx-auto"
      >
        <span className={`font-eyebrow text-eyebrow ${eyebrowColor} uppercase tracking-widest block mb-2`}>
          {eyebrow}
        </span>
        <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright mb-stack-md">
          {heading}
        </h2>
        {subhead && (
          <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant">
            {subhead}
          </p>
        )}
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {docs.map((doc, i) => (
          <ResourceCard key={doc.id} resource={doc} index={i} />
        ))}
      </div>

      <div className="text-center mt-stack-lg">
        <Link
          to="/resources"
          className="font-label-sm text-label-sm text-on-surface-variant dark:text-surface-variant hover:text-primary transition-colors uppercase tracking-widest inline-flex items-center gap-1"
        >
          See all resources
          <span className="material-symbols-outlined text-[16px]">arrow_forward</span>
        </Link>
      </div>
    </section>
  );
}
